import { render, staticRenderFns } from "./AnswerAttachmentCreate.vue?vue&type=template&id=123a934c"
import script from "./AnswerAttachmentCreate.vue?vue&type=script&lang=js"
export * from "./AnswerAttachmentCreate.vue?vue&type=script&lang=js"
import style0 from "./AnswerAttachmentCreate.vue?vue&type=style&index=0&id=123a934c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports